export function isTerassenTable(t) {
  if (!t) {
    return false;
  }

  return parseInt(t) >= 200;

}
